import httpService from "./httpService";
import utils from "./utils";

export default {
  search(keyword) {
    keyword && (keyword = keyword.trim());

    return httpService.get("usersView/search", {
      params: {keyword: keyword}
    });
  },

  searchForCC(keyword) {
    keyword && (keyword = keyword.trim());

    return httpService.get("usersView/search", {
      params: {keyword: keyword}
    });
  },

  findById(id) {
    return httpService.get("usersView/" + id, null);
  },

  findAllByDeptIdAndRoleIdAndId(deptId, roleId, id) {
    return httpService.get("usersView/findAllByDeptIdAndRoleIdAndId", {
      params: {deptId: deptId, roleId: roleId, id: id}
    });
  },

  findAllByIdIn(ids, pageable) {
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge({ids: ids}, pageable);

    return httpService.get("usersView/findAllByIdIn", {params: params});
  },

  findAll(usingAdvanceSearch, keyword, form, pageable, isAdmin) {
    let params = utils.merge(utils.merge({
      usingAdvanceSearch: usingAdvanceSearch,
      keyword: keyword,
      isAdmin: isAdmin
    }, form), pageable);
    return httpService.get("/usersView", {params: params});
  },

  count(usingAdvanceSearch, keyword, form) {
    let params = utils.merge({usingAdvanceSearch: usingAdvanceSearch, keyword: keyword}, form);
    return httpService.get("/usersView/count", {params: params});
  },

  activeUser(id) {
    return httpService.post("/usersView/active", id);
  },
  deactiveUser(id) {
    return httpService.post("/usersView/deactive", id);
  },

};



// WEBPACK FOOTER //
// ./src/services/usersViewService.js